import React from 'react';
import { TypographyBase } from '@fmc-digital/ui';

interface LoanDeatilsProps {
    title: string;
    value: string;
}

export const LoanDeatils = ({ title, value }: LoanDeatilsProps) => (
    <TypographyBase>
        <TypographyBase variant="paragraph-bold">{title}</TypographyBase>
        <TypographyBase>{value}</TypographyBase>
    </TypographyBase>
);
